import { render, staticRenderFns } from "./dyxDisGroup.vue?vue&type=template&id=c2c689d0&scoped=true"
import script from "./dyxDisGroup.vue?vue&type=script&lang=js"
export * from "./dyxDisGroup.vue?vue&type=script&lang=js"
import style0 from "./dyxDisGroup.vue?vue&type=style&index=0&id=c2c689d0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c689d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c689d0')) {
      api.createRecord('c2c689d0', component.options)
    } else {
      api.reload('c2c689d0', component.options)
    }
    module.hot.accept("./dyxDisGroup.vue?vue&type=template&id=c2c689d0&scoped=true", function () {
      api.rerender('c2c689d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dyxmanager/dyxDisGroup/dyxDisGroup.vue"
export default component.exports